<template>
  <v-container>
    <h1 class="headline">Account Completion</h1>
    <p class="caption font-italic">You are almost there!</p>
    <v-row>
      <v-col cols="12" sm="6">
        <PharmacySelect></PharmacySelect>
        <h1 v-if="approvalVisible">{{ account_approved }}</h1>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card v-if="!email_verified" height="100%">
          <v-card-title class="headline primary lighten-3">
            email verification
          </v-card-title>
          <v-card-text class="pa-5">
            <div>
              <h2 class="title">Email address verification</h2>
              <p>
                ‌According to our database, this email address has not been
                verified yet. Did you just verify it?
                <v-btn
                  color="blue darken-1"
                  depressed
                  text
                  small
                  :loading="email_verification_button_loading"
                  @click="checkEmailVerification"
                  >Let's check again</v-btn
                >
              </p>
              <p>
                If you have not received the verification email, use the button
                below. to verify your email address.
              </p>
              <v-btn color="primary" dark class="mb-2" @click="verifyEmail"
                >Send Verification Email</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ dialogMessages.title }}</v-card-title>
        <v-card-text v-html="dialogMessages.body"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <div class="text-center ma-2">
        <v-snackbar v-model="showVerificationEmailSentSnackbar">
          Verification email was sent.
          <v-btn
            color="accent"
            text
            @click="showVerificationEmailSentSnackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </div>
    </template>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import PharmacySelect from "@/components/PharmacySelect.vue";

export default {
  mounted() {
    firebase
      .auth()
      .currentUser.getIdTokenResult(true)
      .then(tokenResult => {
        const claims = tokenResult.claims;
        this.email_verified = !!claims.email_verified;
        this.pharmacy_set = !!claims.pharmacy_set;
        this.account_approved = !!claims.account_approved;
      });
  },
  computed: {
    approvalVisible() {
      return this.email_verified && this.pharmacy_set;
    },
    dialogMessages() {
      if (this.serverError) {
        return {
          title: "Something went wrong!",
          body: "Can't send verification Email. Please try again later."
        };
      }
      if (this.email_verified) {
        return {
          title: "Congratulations!",
          body: "Your email is verified."
        };
      }
      return {
        title: "Email Not Verified Yet",
        body:
          "According to our records your email address hasn't verified yet. If you haven't receive the verification email, use the <b>\"SEND VERIFICATION EMAIL\"</b> button in this page."
      };
    }
  },
  data() {
    return {
      email_verified: true,
      pharmacy_set: false,
      account_approved: false,
      email_verification_button_loading: false,
      dialog: false,
      showVerificationEmailSentSnackbar: false,
      serverError: false
    };
  },
  components: {
    PharmacySelect
  },
  methods: {
    verifyEmail: function() {
      this.showVerificationEmailSentSnackbar = false;
      firebase
        .auth()
        .currentUser.sendEmailVerification()
        .then(() => {
          this.showVerificationEmailSentSnackbar = true;
        })
        .catch(err => {
          console.log(err);
          if (err.code === "auth/too-many-requests") {
            this.serverError = true;
            this.dialog = true;
          }
        });
    },
    checkEmailVerification: function() {
      this.email_verification_button_loading = true;
      firebase
        .auth()
        .currentUser.getIdTokenResult(true)
        .then(tokenResult => {
          const claims = tokenResult.claims;
          this.email_verified = !!claims.email_verified;
          this.email_verification_button_loading = false;
          this.dialog = true;
        });
    },
    closeDialog: function() {
      this.dialog = false;
      this.serverError = false;
    }
  }
};
</script>
